import React from 'react';
import MaterialCheckbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {I18n} from 'react-redux-i18n';

export default props => {
  const {
    label,
    checked,
    onChange,
    disabled = false,
    id
  } = props;

  const handleChange = (event, value) => {
    return onChange && onChange(event, value);
  };

  return (
    <FormControlLabel
      label={label}
      control={
        <MaterialCheckbox
          checked={checked}
          id={id}
          disabled={disabled}
          onChange={handleChange}
        />
      }
    />
  );
};
